module.exports = __webpack_public_path__ + "static/media/loading.57ca1a20.gif";